import axios from "axios";

const BASE_URL =
    process.env.REACT_APP_API_URL;

// ================= GET FOOD REFUND HISTORY =================
export const getFoodRefundHistoryAPI =
    async () => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "Authentication token not found. Please login again."
                );
            }

            const response =
                await axios.get(
                    `${BASE_URL}/food/api/refundhistory/all`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,

                            "Content-Type":
                                "application/json",
                        },
                    }
                );

            if (
                !Array.isArray(
                    response.data
                )
            ) {
                throw new Error(
                    "Unexpected response format"
                );
            }

            // Filter payment methods
            const filteredPayments =
                response.data.filter(
                    (item) =>
                        item.paymentMethod ===
                        "Online_Payment" ||
                        item.paymentMethod ===
                        "Maamaas_Wallet"
                );

            // Add serial numbers
            return filteredPayments.map(
                (
                    item,
                    index
                ) => ({
                    ...item,

                    sno:
                        index + 1,
                })
            );

        } catch (error) {
            console.error(
                "❌ Error fetching refund history:",
                error
            );

            throw error;
        }
    };

// ================= GET REFUND DETAILS =================
export const getRefundDetailsAPI =
    async (refundId) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "Authentication token is missing."
                );
            }

            const response =
                await fetch(
                    `${BASE_URL}/food/api/refundhistory/get/order/${refundId}`,
                    {
                        method:
                            "GET",

                        headers: {
                            "Content-Type":
                                "application/json",

                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            if (!response.ok) {
                throw new Error(
                    `Failed to fetch refund details. Status: ${response.status}`
                );
            }

            const data =
                await response.json();

            let refundDetails =
                null;

            if (data?.refundId) {
                refundDetails =
                    data;
            } else if (
                Array.isArray(
                    data
                ) &&
                data.length > 0
            ) {
                refundDetails =
                    data[0];
            } else if (
                data?.data
                    ?.refundId
            ) {
                refundDetails =
                    data.data;
            } else {
                throw new Error(
                    "Refund details not found in response."
                );
            }

            return refundDetails;

        } catch (error) {
            console.error(
                "❌ Error fetching refund details:",
                error
            );

            throw error;
        }
    };

// ================= PROCESS REFUND =================
export const processRefundAPI =
    async (
        selectedRefund
    ) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "Authentication token is missing."
                );
            }

            if (
                !selectedRefund ||
                !selectedRefund.transactionId ||
                !selectedRefund.price
            ) {
                throw new Error(
                    "Missing transaction ID or amount."
                );
            }

            // ONLINE PAYMENT REFUND
            if (
                selectedRefund.paymentMethod ===
                "Online_Payment"
            ) {
                const refundResponse =
                    await fetch(
                        `${BASE_URL}/food/api/payments/refund`,
                        {
                            method:
                                "POST",

                            headers: {
                                "Content-Type":
                                    "application/json",

                                Authorization:
                                    `Bearer ${token}`,
                            },

                            body: JSON.stringify(
                                {
                                    payment_id:
                                        selectedRefund.transactionId,
                                }
                            ),
                        }
                    );

                const refundResult =
                    await refundResponse.json();

                if (
                    !refundResponse.ok
                ) {
                    throw new Error(
                        refundResult?.message ||
                        "Refund failed"
                    );
                }
            }

            // WALLET REFUND
            else if (
                selectedRefund.paymentMethod ===
                "Maamaas_Wallet"
            ) {
              
            }

            // UPDATE REFUND HISTORY
            const updateResponse =
                await fetch(
                    `${BASE_URL}/food/api/refundhistory/update/${selectedRefund.refundId}/REFUNDED`,
                    {
                        method:
                            "PUT",

                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            const updateResult =
                await updateResponse.json();

            if (
                !updateResponse.ok
            ) {
                throw new Error(
                    updateResult?.message ||
                    "History update failed"
                );
            }

            return updateResult;

        } catch (error) {
            console.error(
                "❌ Refund process error:",
                error
            );

            throw error;
        }
    };

export const getAllDeliverySettlementsAPI =
    async () => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            const response =
                await axios.get(
                    `${BASE_URL}/delivery/api/admin/get/settlements/all`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,

                            Accept:
                                "*/*",
                        },
                    }
                );

            return (
                response.data
                    .settlements ||
                response.data ||
                []
            );

        } catch (error) {
            console.error(
                "❌ Error fetching settlements:",
                error
            );

            throw error;
        }
    };

// ================= GET SETTLEMENT BY ID =================
export const getDeliverySettlementByIdAPI =
    async (
        settlementId
    ) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            const response =
                await axios.get(
                    `${BASE_URL}/delivery/api/get/settlement/id?id=${settlementId}`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,

                            Accept:
                                "*/*",
                        },
                    }
                );

            return response.data;

        } catch (error) {
            console.error(
                "❌ Error fetching settlement details:",
                error
            );

            throw error;
        }
    };

// ================= CHECK ADMIN WALLET BALANCE =================
export const checkAdminWalletBalanceAPI =
    async () => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            const response =
                await axios.get(
                    `${BASE_URL}/delivery/api/admin/wallet/balance`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,

                            Accept:
                                "*/*",
                        },
                    }
                );

            return parseFloat(
                response.data
                    .balance ||
                response.data
                    .availableBalance ||
                response.data
            );

        } catch (error) {
            console.error(
                "❌ Error fetching wallet balance:",
                error
            );

            throw error;
        }
    };

// ================= UPDATE DELIVERY SETTLEMENT STATUS =================
export const updateDeliverySettlementStatusAPI =
    async ({
        settlementId,
        amount,
        transactionId,
    }) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            const params =
                new URLSearchParams(
                    {
                        id: settlementId,

                        amount:
                            amount.toString(),

                        transactionId:
                            transactionId.trim(),
                    }
                );

            const response =
                await axios.put(
                    `${BASE_URL}/delivery/api/admin/update/settlement/status?${params.toString()}`,
                    null,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,

                            "Content-Type":
                                "application/json",
                        },
                    }
                );

            return response.data;

        } catch (error) {
            console.error(
                "❌ Error updating settlement status:",
                error
            );

            throw error;
        }
    };


// ================= GET ADVERTISEMENT =================
export const getAdvertisementAPI =
    async () => {

        try {

            const token =
                localStorage.getItem(
                    "authToken"
                );

            const adminId =
                localStorage.getItem(
                    "userId"
                );

            const response =
                await axios.get(
                    `${BASE_URL}/food/superadmin/advertisement/admin/${adminId}`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,

                            accept:
                                "*/*",
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "❌ GET Advertisement Error:",
                error
            );

            throw error;
        }
    };

// ================= SAVE / UPDATE ADVERTISEMENT =================
export const saveAdvertisementAPI =
    async ({
        adId,
        pTitle1,
        pTitle2,
        pDesc,
        mediaFile,
    }) => {

        try {

            const adminId =
                localStorage.getItem(
                    "userId"
                );

            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!adminId) {
                throw new Error(
                    "Admin ID missing!"
                );
            }

            const formData =
                new FormData();

            const dataObject = {
                id: adId
                    ? adId
                    : 0,

                title:
                    `${pTitle1} ${pTitle2}`,

                description:
                    pDesc,

                adminId:
                    Number(adminId),
            };

            formData.append(
                "data",

                new Blob(
                    [
                        JSON.stringify(
                            dataObject
                        ),
                    ],
                    {
                        type:
                            "application/json",
                    }
                )
            );

            if (mediaFile) {
                formData.append(
                    "file",
                    mediaFile
                );
            }

            const url = adId
                ? `${BASE_URL}/food/superadmin/advertisement/edit/${adId}`
                : `${BASE_URL}/food/superadmin/advertisement/add/${adminId}`;

            const response =
                await axios.post(
                    url,
                    formData,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,

                            "Content-Type":
                                "multipart/form-data",
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "❌ Save Advertisement Error:",
                error
            );

            throw error;
        }
    };

// ================= UPDATE ADVERTISEMENT =================
export const updateAdvertisementAPI =
    async ({
        adId,
        pTitle1,
        pTitle2,
        pDesc,
        mediaFile,
    }) => {

        try {

            const token =
                localStorage.getItem(
                    "authToken"
                );

            const formData =
                new FormData();

            const dataObject = {
                id: adId,

                title:
                    `${pTitle1} ${pTitle2}`,

                description:
                    pDesc,

                adminId:
                    Number(
                        localStorage.getItem(
                            "userId"
                        )
                    ),
            };

            formData.append(
                "data",

                new Blob(
                    [
                        JSON.stringify(
                            dataObject
                        ),
                    ],
                    {
                        type:
                            "application/json",
                    }
                )
            );

            if (mediaFile) {
                formData.append(
                    "file",
                    mediaFile
                );
            }

            const response =
                await axios.put(
                    `${BASE_URL}/food/superadmin/advertisement/edit/${adId}`,
                    formData,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,

                            "Content-Type":
                                "multipart/form-data",
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "❌ Update Advertisement Error:",
                error
            );

            throw error;
        }
    };

// ================= DELETE ADVERTISEMENT =================
export const deleteAdvertisementAPI =
    async (adId) => {

        try {

            const token =
                localStorage.getItem(
                    "authToken"
                );

            const response =
                await axios.delete(
                    `${BASE_URL}/food/superadmin/advertisement/delete/${adId}`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "❌ Delete Advertisement Error:",
                error
            );

            throw error;
        }
    };


export const getAllVendorEnquiries = async () => {

    const token =
        localStorage.getItem("authToken");

    const response = await axios.get(
        `${BASE_URL}/vendor-enquiries/getall`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

    return response.data;
};